import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _activity = {
    activityDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    toolCallsRequested: '_toolCallsRequested',
};
var _createActivityRequest = { activity: '_activity' };
var _createActivityResponse = { activity: '_activity' };
var _getActivityRequest = {};
var _getActivityResponse = { activity: '_activity' };
var _queryActivitiesRequest = {};
var _queryActivitiesResponse = { activities: '_activity' };
var _responseMetadata = { cost: 'DOUBLE' };
var _toolCallsRequested = { responseMetadata: '_responseMetadata' };
function resolveWixAgentmakerActivitiesV1AgentMakerActivitiesUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/agent-maker-activities',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/agent-maker-activities',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/agent-maker-activities',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/agent-maker-activities',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a Activity. */
export function createActivity(payload) {
    var _a = serializer(_createActivityRequest, { _activity: _activity, _responseMetadata: _responseMetadata, _toolCallsRequested: _toolCallsRequested }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createActivityResponse, {
        _activity: _activity,
        _responseMetadata: _responseMetadata,
        _toolCallsRequested: _toolCallsRequested,
    }).fromJSON;
    function __createActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.v1.activity',
            method: 'POST',
            methodFqn: 'wix.agentmaker.activities.v1.AgentMakerActivities.CreateActivity',
            url: resolveWixAgentmakerActivitiesV1AgentMakerActivitiesUrl({
                protoPath: '/v1/activities',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createActivity.fromReq = fromReq;
    __createActivity.__isAmbassador = true;
    return __createActivity;
}
/** Retrieves a Activity. */
export function getActivity(payload) {
    var _a = serializer(_getActivityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getActivityResponse, {
        _activity: _activity,
        _responseMetadata: _responseMetadata,
        _toolCallsRequested: _toolCallsRequested,
    }).fromJSON;
    function __getActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.v1.activity',
            method: 'GET',
            methodFqn: 'wix.agentmaker.activities.v1.AgentMakerActivities.GetActivity',
            url: resolveWixAgentmakerActivitiesV1AgentMakerActivitiesUrl({
                protoPath: '/v1/activities/{activityId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getActivity.fromReq = fromReq;
    __getActivity.__isAmbassador = true;
    return __getActivity;
}
/** Retrieves a list of Activities, given the provided [paging, filtering, and sorting] */
export function queryActivities(payload) {
    var _a = serializer(_queryActivitiesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryActivitiesResponse, {
        _activity: _activity,
        _responseMetadata: _responseMetadata,
        _toolCallsRequested: _toolCallsRequested,
    }).fromJSON;
    function __queryActivities(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.v1.activity',
            method: 'GET',
            methodFqn: 'wix.agentmaker.activities.v1.AgentMakerActivities.QueryActivities',
            url: resolveWixAgentmakerActivitiesV1AgentMakerActivitiesUrl({
                protoPath: '/v1/activities/query',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixAgentmakerActivitiesV1AgentMakerActivitiesUrl({
                        protoPath: '/v1/activities/query',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __queryActivities.fromReq = fromReq;
    __queryActivities.__isAmbassador = true;
    return __queryActivities;
}
//# sourceMappingURL=http.impl.js.map